<h2 mat-dialog-title class="asset-field-dialog__title">{{ 'title.new_asset_field' | translate }}</h2>

<mat-dialog-content class="asset-field-dialog__content" [formGroup]="form">
  <label class="asset-field-dialog__field">
    <span class="asset-field-dialog__label">{{ 'label.display_name' | translate | uppercase }}</span>
    <input
      class="ts-input"
      type="text"
      formControlName="displayName"
      data-cy="asset-field-display-name"
    />
  </label>

  <label class="asset-field-dialog__field">
    <span class="asset-field-dialog__label">{{ 'label.field_path' | translate | uppercase }}</span>
    <input
      class="ts-input"
      type="text"
      formControlName="fieldPath"
      data-cy="asset-field-field-path"
    />
  </label>
</mat-dialog-content>

<mat-dialog-actions class="asset-field-dialog__actions">
  <button
    type="button"
    class="btn btn-outline-primary asset-field-dialog__action"
    (click)="cancel()"
    data-cy="asset-field-cancel"
  >
    {{ 'button.cancel' | translate }}
  </button>
  <button
    type="button"
    class="btn btn-primary asset-field-dialog__action"
    [disabled]="!canSave"
    (click)="save()"
    data-cy="asset-field-save"
  >
    {{ 'button.continue' | translate }}
  </button>
</mat-dialog-actions>
